<mat-card *ngIf="urlForm">
  <p8-layout-settings-header [titlePath]="['Association de lien à un formulaire publié ou hors ligne']"></p8-layout-settings-header>
  <mat-card-content>
    <div style="padding-top: 20px;">
      <p class="mat-h3">Lien actuel </p>
      <p style="padding-left: 15px;">{{formSvc.formUrlDemandeurBySlug(urlForm.slug)}}
      <p>&nbsp;</p>
      <p class="mat-h3" >Pointera vers le formulaire :</p>
    </div>
    <div  style="padding-left: 15px;">
      <mat-progress-bar [mode]="'indeterminate'" *ngIf="loading"></mat-progress-bar>
      <mat-form-field appearance="outline">
        <mat-select [(ngModel)]="formSelected"
                    (selectionChange)="onSelect($event)"
                    required="required"
                    data-cy="select-url-edit">
          <mat-option *ngFor="let form of forms"
                      [value]="form"
                      [matTooltip]="form?.nom" [attr.data-cy]="'option-url-edit-'+form.id">
            <span style="{{getStyleStateForm(form)}}">&nbsp;&nbsp;</span>&nbsp;
            {{ form.nom }} <span [innerHTML]="labelCurrentForm(form)"></span>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-icon-button
              (click)="visualize()"
              [disabled]="isPreviewDisabled()"
              matTooltip="Visualiser le formulaire sélectionné"
              data-cy="button-url-edit-visualize">
        <mat-icon data-cy="icon-url-edit-remove-red-eye">remove_red_eye</mat-icon>
      </button>
      <div>
        <span>Le formulaire <strong>{{urlForm?.form_obj?.nom}}</strong> sera <strong>archivé</strong> à l'issue de son remplacement.</span>
      </div>
    </div>
    <mat-card-actions align="end">
      <button mat-raised-button color="warn"
              [disabled]="isMappingDisabled()"
              (click)="changeFormUrl()"
              matTooltipPosition="right" matTooltip="Modifier le formulaire cible" data-cy="button-url-edit-cancel"> Modifier le formulaire cible</button>
      <button mat-raised-button (click)="close()">Annuler</button>
    </mat-card-actions>
  </mat-card-content>
</mat-card>
